import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AddressValidationService } from '@core/services/address-validation/address-validation.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query QueryAddressGeocodeGQL ($input: AddressGeocodeInput!) {\n    addressGeocode (input: $input) {\n      postalCode\n      streetName\n      city\n      number\n      state\n      complement\n      neighborhood\n      formattedAddress\n      coords {\n        latitude\n        longitude\n      }\n    }\n  }\n"], ["\n  query QueryAddressGeocodeGQL ($input: AddressGeocodeInput!) {\n    addressGeocode (input: $input) {\n      postalCode\n      streetName\n      city\n      number\n      state\n      complement\n      neighborhood\n      formattedAddress\n      coords {\n        latitude\n        longitude\n      }\n    }\n  }\n"])));
var FcAddressInputComponent = /** @class */ (function () {
    function FcAddressInputComponent(fuseTranslationLoaderService, addressValidationService, apollo) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.addressValidationService = addressValidationService;
        this.apollo = apollo;
        this.options = [];
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.preloadOptions = false;
        this.searchOnFocus = false;
        this.removeSubscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcAddressInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.control.valueChanges.pipe(takeUntil(this.removeSubscriptions))
            .subscribe(function (address) {
            _this.validation = _this.addressValidationService.validateAddress(address);
            if (_this.validation && _this.validation.errors && _this.validation.errors.length) {
                _this.control.setErrors({
                    invalid: true
                });
                return;
            }
        });
    };
    FcAddressInputComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    FcAddressInputComponent.prototype.search = function (searchTerm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            input: {
                                formattedAddress: searchTerm,
                                language: navigator.language || 'pt-BR'
                            },
                        },
                    })
                        .toPromise()
                        .then(function (result) {
                        return result.data['addressGeocode'];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcAddressInputComponent.prototype.displayWith = function (value) {
        return value && value.formattedAddress;
    };
    return FcAddressInputComponent;
}());
export { FcAddressInputComponent };
var templateObject_1;
